// frontend/src/components/ViewTerminalModal.tsx
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { TerminalHealth } from "./types"; // Adjust import path as needed

interface ViewTerminalModalProps {
  terminalHealth: TerminalHealth;
  onClose: () => void;
}

export default function ViewTerminalHealthModal({
  terminalHealth,
  onClose,
}: ViewTerminalModalProps): JSX.Element {
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <div className="mb-4">
          <DialogTitle className="text-lg font-bold">
            Terminal Details
          </DialogTitle>
        </div>
        <div className="space-y-2">
          <p className="flex items-center justify-between">
            <span className="font-bold">ID</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>
            <span className="text-gray-600">{terminalHealth._id}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">App Version:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>
            <span className="text-gray-600">{terminalHealth.appVersion}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Battery Level:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>

            <span className="text-gray-600">{terminalHealth.batteryLevel}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Created At:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>
            <span className="text-gray-600">
              {new Date(terminalHealth.createdAt).toLocaleString()}
            </span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Date Time:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>
            <span className="text-gray-600">{terminalHealth.dateTime}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Location:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>
            <span className="text-gray-600">{terminalHealth.location}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Printer Status:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>

            <span className="text-gray-600">
              {terminalHealth.printerStatus}
            </span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Serial Number:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>

            <span className="text-gray-600">{terminalHealth.serialNumber}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Terminal ID:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>
            <span className="text-gray-600">{terminalHealth.terminalId}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Terminal Type:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>

            <span className="text-gray-600">{terminalHealth.terminalType}</span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Updated At:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>
            <span className="text-gray-600">
              {new Date(terminalHealth.updatedAt).toLocaleString()}
            </span>
          </p>
          <p className="flex items-center justify-between">
            <span className="font-bold">Paper Level:</span>
            <span className="flex-1 mx-4 border-b border-dashed border-black rounded-full "></span>

            <span className="text-gray-600">
              {terminalHealth.paperLevel || "N/A"}
            </span>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
